import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * A highlighted answer on a graded question — either the one the learner chose
 * or, when they got it wrong, the one that was correct.
 *
 * Props:
 *   id          (string) - Element ID.
 *   variant     (string) - 'correct' or 'incorrect'; picks the border colour.
 *   heading     (string) - e.g. "You chose the correct answer!".
 *   optionKey   (string) - The answer's letter.
 *   optionText  (string) - The answer's text.
 *   hideKey     (bool)   - Drops the letter, for True/False, where it says nothing.
 *   explanation (string) - Optional; why this answer was wrong, shown under it.
 */
export const AnswerBox = ({
  id,
  variant,
  heading,
  optionKey,
  optionText,
  hideKey,
  explanation,
}) => (
  <Box className={`answerBox ${variant}`} id={id}>
    <Typography className="answerBoxHeading">{heading}</Typography>
    <Typography className="answerBoxText">
      {!hideKey && <span className="optionKey">{optionKey}.</span>}
      {optionText}
    </Typography>
    {explanation && (
      <Typography className="answerBoxExplanation" id={id && `${id}__explanation`}>
        <strong>Explanation:</strong> {explanation}
      </Typography>
    )}
  </Box>
);
